var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSquareSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C2.118 24 0 21.882 0 12C0 2.118 2.118 0 12 0C21.882 0 24 2.118 24 12C24 21.882 21.882 24 12 24ZM11 6C11 5.44769 11.4478 5 12 5C12.5522 5 13 5.44769 13 6V11H18C18.5522 11 19 11.4477 19 12C19 12.5523 18.5522 13 18 13H12C11.4478 13 11 12.5523 11 12V6Z",
    fill: "#FABC73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSquareSmall);
export default __webpack_public_path__ + "static/media/time-square-small.492280823a9e8ecbf350d263b03085e0.svg";
export { ForwardRef as ReactComponent };